export function* traceDepsToTerms(deps, refs) {
    var _a, _b, _c;
    if (!deps) {
        return;
    }
    for (const dep of deps) {
        if (dep.type === "iterable") {
            if (dep.property === "count") {
                yield* traceDepsToTerms(refs.iterables[dep.iterableName].count.dependencies, refs);
            }
            continue;
        }
        // If the property is value then we've reached a term
        if (dep.property === "value" ||
            dep.property === "ready" ||
            dep.property === "hasValue" ||
            dep.property === "isComplete" ||
            dep.property === "isValid") {
            yield dep;
        }
        const expNames = mapTermPropertiesToExpressionNames(dep.property);
        if (!expNames.length) {
            continue;
        }
        for (const expName of expNames) {
            const depRef = dep.type === "iterable-term"
                ? (_b = (_a = refs.iterables[dep.iterableName]) === null || _a === void 0 ? void 0 : _a.terms[dep.termName]) === null || _b === void 0 ? void 0 : _b[expName]
                : (_c = refs.terms[dep.termName]) === null || _c === void 0 ? void 0 : _c[expName];
            if (depRef) {
                yield* traceDepsToTerms(depRef.dependencies, refs);
            }
        }
    }
}
// We've come across a term property, some are static and some are reactive
// if they are reactive then we need to trace their dependencies
function mapTermPropertiesToExpressionNames(prop) {
    switch (prop) {
        case "value":
        case "ready":
        case "hasValue":
            return ["calculate"];
        case "label":
            return ["label"];
        case "isRelevant":
            return ["relevant"];
        case "isRequired":
            return ["required"];
        case "isReadonly":
            return ["readonly"];
        case "isValid":
            return ["calculate", "validation"];
        case "isComplete":
            return ["calculate", "relevant", "required", "validation"];
        case "enums":
            return ["enumsRelevant"];
        default:
            return [];
    }
}
//# sourceMappingURL=trace-deps-to-terms.js.map